import { JsEnv } from '../../../../core/models/js_env';
import { KeywordJsEnv } from '../../models/keyword_js_env';
import { Keyword } from '../../models/keyword';
import { TypedEvent } from '../../../../core/typed_event';

export class CatalogAction {
  static readonly UPDATE_EVENT = new TypedEvent<KeywordJsEnv>();
  private static state: Keyword;
  static init(env: JsEnv, containerClass: any) {
    this.state = new Keyword(env.PAGE);
    const model = this.state.getModel();

    return new containerClass(model);
  }

  static async inputPublishedPage() {
    const publishedPage: HTMLInputElement = <HTMLInputElement>document.getElementById('publishedPage');
    this.state.setPublishedPage(publishedPage.value);
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }
}
